import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode';

export const isSessionAboutToExpire = (sessionToken: string) => {
  const decoded = jwtDecode(sessionToken);
  const currentTime = Date.now() / 1000;
  // check if the session is expiring in the next 60 seconds
  if (decoded.exp && decoded.exp - 60 < currentTime) {
    return true;
  }
  return false;
};

export const setRefreshToken = (refreshToken: string) => {
  const currentHostName = window.location.hostname;
  let domain = '';
  if (currentHostName.includes('bond.now')) {
    domain = '.bond.now';
  } else if (currentHostName.includes('dots.link')) {
    domain = '.dots.link';
  } else {
    domain = 'BondAp-BondA-3usszafikZLd-293207441.us-west-2.elb.amazonaws.com';
  }

  Cookies.set('refreshToken', refreshToken, {
    secure: process.env.NODE_ENV === 'production',
    sameSite: 'strict',
    domain: process.env.NODE_ENV === 'production' ? domain : 'localhost',
    expires: 30,
  });
};

export const shouldSkipRedirectionOnAuthError = (path: string) => {
  const publicPaths = ['/signup', '/invite', '/profile'];

  return publicPaths.some((publicPath) => path.startsWith(publicPath));
};
